<form #detachTrailerForm="ngForm">
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.detach-trailer"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-string-field name="value" [(ngModel)]="stepperModel.workingData.swapTrailerNumber"
    #ctrlSwapTrailerNumber="ngModel"
    labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.swapTrailerNumber"
    [required]="true" grow></sc-string-field>
</form>
